module.exports = __webpack_public_path__ + "static/media/selo-diamante-de-inovacao.7dfb15e1.pdf";